import { createContext, useContext, useEffect, useState } from "react";
import { FunnelStageResponse } from "@/modules/lead-page/types";
import { GetLeadResponse } from "@/modules/leads/dtos";
import useAuth from "@/modules/common/hooks/auth.hook";

export const LeadPageContext = createContext<{
  lead: GetLeadResponse | undefined;
  stages?: FunnelStageResponse | undefined;
  isStagesLoading?: boolean;
}>({
  lead: {} as GetLeadResponse,
  stages: {} as FunnelStageResponse,
  isStagesLoading: false,
});

export function useLeadContext() {
  const { user } = useAuth();

  const { lead } = useContext(LeadPageContext);

  const [isAssignedAgent, setAssignedAgent] = useState(
    user?.["cognito:username"] === lead?.data?.lead?.user?.id?.toString()
  );

  useEffect(() => {
    if (lead && user) {
      setAssignedAgent(
        user?.["cognito:username"] === lead?.data?.lead?.user?.id?.toString()
      );
    }
  }, [lead, user]);

  return {
    lead,
    isAssignedAgent,
  };
}
